export default {
  BROWSER: 'BROWSER',
  ANDROID: 'ANDROID',
  ANDROID_STB: 'ANDROID_STB',
  EMBEDDED_PLAYER: 'EMBEDDED_PLAYER',
  IOS: 'IOS',
  SMART_TV: 'SMART_TV',
};
